import React from "react";
import styles from "./solar-consumption.module.scss";
import CustomerPageLayout from "../customer-page-layout/CustomerPageLayout";
import useWindowDimensions, { CurrentScreen } from "../../../hooks/use-window-dimensions";
import { useGetCustomerSolarMetersQuery } from "../../../service/vending-service";
import { WeatherWidget } from "./components/weather-widget";
import { ConsumptionChart } from "./components/consumption-chart";
import { ConsumptionPattern } from "./components/consumption-pattern";
import { SolarControls } from "./components/solar-controls";

export const SolarConsumption = () => {
	const currentScreen: CurrentScreen = useWindowDimensions();
	const { data: solarMeters, isLoading: isLoadingMeters } = useGetCustomerSolarMetersQuery();

	const subscriptionId = solarMeters?.[0]?.payAsYouGoSubscriptionId ?? "";
	const hasSubscription = !!subscriptionId;

	return (
		<CustomerPageLayout title="Solar Consumption" subtitle="Monitor your solar energy generation and usage.">
			<div className={styles.container}>
				<div className={styles.topRow}>
					<WeatherWidget />
					<ConsumptionChart
						subscriptionId={subscriptionId}
						isReady={hasSubscription}
					/>
				</div>
				<div className={styles.bottomRow}>
					<ConsumptionPattern
						subscriptionId={subscriptionId}
						isReady={hasSubscription}
					/>
					<SolarControls
						subscriptionId={subscriptionId}
						isReady={hasSubscription}
					/>
				</div>
			</div>
		</CustomerPageLayout>
	);
};
